<template>
  <VTable
    v-if="table.data.length"
    :table="table"
    class="manager-company-opportunity-lookup-appointments"
  />
  <VFallbackText v-else>No data found</VFallbackText>
</template>

<script setup lang="ts">
  // Types
  import type { ITable } from '~/misc/v-table/types';
  import type { TManagerCompanyOpportunityLookupAppointment } from '~/modules/manager/types';

  // Config
  import { TABLE_HEADERS } from '~/modules/manager/company/opportunity-lookup/result/appointments/config';

  // Utils
  import { DateTimeFormatter } from '~/misc/utils/datetime';

  // Components
  import VTable from '~/misc/v-table';
  import VFallbackText from '~/misc/v-fallback-text/VFallbackText.vue';

  const props = defineProps({
    data: {
      type: Array as PropType<TManagerCompanyOpportunityLookupAppointment[]>,
      required: true,
    },
  });

  const table: ComputedRef<ITable> = computed<ITable>(() => ({
    headers: TABLE_HEADERS,
    data: props.data.length
      ? props.data.map((item: TManagerCompanyOpportunityLookupAppointment) => [
          item.type || '-',
          item.is_market_appraisal ? 'Yes' : 'No',
          item.description || '-',
          item.external_created_at ? DateTimeFormatter.toShortDate(item.external_created_at) : '-',
          item.external_updated_at ? DateTimeFormatter.toShortDate(item.external_updated_at) : '-',
        ])
      : [],
  }));
</script>
